import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces } from '../../theme';

export const useSimpleConfirmDialogStyles = createStyles(({ token }) => ({
  simpleConfirmDialog: {
    '&&': {
      '.SimpleDialog-Icon': {
        '> *': {
          color: ThemeColors.COLOR_ORANGE3,
        },
        '&::before': {
          top: 6,
          bottom: 2,
          right: 10,
          left: 10,
        },
      },

      '.ant-modal-content, .ant-modal-body': {
        minHeight: 140,
      },

      '.ant-modal-body': {
        padding: ThemeSpaces.SPACE_NORM_20,
        paddingTop: ThemeSpaces.SPACE_NORM_25,
      },

      'h1.ant-typography': {
        lineHeight: 1,
        marginBottom: ThemeSpaces.SPACE_NORM,

        [`@media (max-width: ${token.screenSMMax}px)`]: {
          fontSize: token.fontSizeHeading2,
        },
        [`@media (min-width: ${token.screenMDMin}px)`]: {
          fontSize: 32,
        },
      },

      'span.ant-typography': {
        lineHeight: '19px',
        textAlign: 'center',

        [`@media (max-width: ${token.screenSMMax}px)`]: {
          fontSize: token.fontSize,
        },
        [`@media (min-width: ${token.screenMDMin}px)`]: {
          fontSize: token.fontSizeLG,
        },
      },

      '.ant-btn': {
        width: '100%',
        fontWeight: 500,

        [`@media (max-width: ${token.screenSMMax}px)`]: {
          height: 28,
          borderRadius: token.borderRadiusSM,
        },
      },

      '&.size-sm': {
        '.ant-modal-content, .ant-modal-body': {
          minHeight: 125,
        },

        'h1.ant-typography': {
          fontSize: token.fontSizeHeading2,
          fontWeight: 300,
          lineHeight: '36px',
        },

        'span.ant-typography': {
          fontSize: token.fontSize,
        },

        '.ant-btn': {
          height: 21,
          borderRadius: token.borderRadiusSM,
        },
      },
    },
  },
  subtitle: {
    color: `${ThemeColors.COLOR_ORANGE3} !important`,
    fontWeight: '700 !important',
  },
  buttons: {
    alignSelf: 'stretch',
    marginTop: ThemeSpaces.SPACE_NORM_15,
  },
  buttonsBorder: {
    marginTop: ThemeSpaces.SPACE_NORM_20,
    marginBottom: ThemeSpaces.SPACE_NORM0_5,
    marginLeft: -ThemeSpaces.SPACE_NORM_20,
    marginRight: -ThemeSpaces.SPACE_NORM_20,
    borderTop: `1px solid ${ThemeColors.COLOR_GREY_DARK5}`,
  },
}));
